import { render } from "./ListCutiTidakSetujuView.vue?vue&type=template&id=0c924840"
import script from "./ListCutiTidakSetujuView.vue?vue&type=script&lang=js"
export * from "./ListCutiTidakSetujuView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__